import {metadaApi} from '@dms/api/base';

import {
  GetInsuranceTypesApiResponse,
  GetInsuranceTypesApiArg,
  GetInsuranceTypesApiResponseSchema,
  GetInsuranceTypesApiArgSchema,
  PostInsuranceTypeApiResponse,
  PostInsuranceTypeApiArg,
  PostInsuranceTypeApiResponseSchema,
  PostInsuranceTypeApiArgSchema,
  GetInsuranceTypeApiResponse,
  GetInsuranceTypeApiArg,
  GetInsuranceTypeApiResponseSchema,
  GetInsuranceTypeApiArgSchema,
  PatchInsuranceTypeApiResponse,
  PatchInsuranceTypeApiArg,
  PatchInsuranceTypeApiResponseSchema,
  PatchInsuranceTypeApiArgSchema,
  DeleteInsuranceTypeApiResponse,
  DeleteInsuranceTypeApiArg,
  DeleteInsuranceTypeApiResponseSchema,
  DeleteInsuranceTypeApiArgSchema,
  PostInsuranceTypeSetActiveApiResponse,
  PostInsuranceTypeSetActiveApiArg,
  PostInsuranceTypeSetActiveApiResponseSchema,
  PostInsuranceTypeSetActiveApiArgSchema,
  PostInsuranceTypeSetInactiveApiResponse,
  PostInsuranceTypeSetInactiveApiArg,
  PostInsuranceTypeSetInactiveApiResponseSchema,
  PostInsuranceTypeSetInactiveApiArgSchema,
  PostInsuranceTypeSetDefaultApiResponse,
  PostInsuranceTypeSetDefaultApiArg,
  PostInsuranceTypeSetDefaultApiResponseSchema,
  PostInsuranceTypeSetDefaultApiArgSchema,
  PostInsuranceTypeUnsetDefaultApiResponse,
  PostInsuranceTypeUnsetDefaultApiArg,
  PostInsuranceTypeUnsetDefaultApiResponseSchema,
  PostInsuranceTypeUnsetDefaultApiArgSchema,
  GetCodelistInsuranceTypesApiResponse,
  GetCodelistInsuranceTypesApiArg,
  GetCodelistInsuranceTypesApiResponseSchema,
  GetCodelistInsuranceTypesApiArgSchema,
} from './types';

export const metadaWorkshopInsuranceTypesApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getInsuranceTypes: build.query<GetInsuranceTypesApiResponse, GetInsuranceTypesApiArg>({
      query: () => ({
        url: `/service/v1/insurance-type`,
      }),
      providesTags: ['insuranceTypesList'],
      extraOptions: {
        responseSchema: GetInsuranceTypesApiResponseSchema,
        requestSchema: GetInsuranceTypesApiArgSchema,
      },
    }),
    postInsuranceType: build.mutation<PostInsuranceTypeApiResponse, PostInsuranceTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: ['insuranceTypesList'],
      extraOptions: {
        responseSchema: PostInsuranceTypeApiResponseSchema,
        requestSchema: PostInsuranceTypeApiArgSchema,
      },
    }),
    getInsuranceType: build.query<GetInsuranceTypeApiResponse, GetInsuranceTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: GetInsuranceTypeApiResponseSchema,
        requestSchema: GetInsuranceTypeApiArgSchema,
      },
    }),
    patchInsuranceType: build.mutation<PatchInsuranceTypeApiResponse, PatchInsuranceTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'insuranceTypesList',
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: PatchInsuranceTypeApiResponseSchema,
        requestSchema: PatchInsuranceTypeApiArgSchema,
      },
    }),
    deleteInsuranceType: build.mutation<DeleteInsuranceTypeApiResponse, DeleteInsuranceTypeApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: ['insuranceTypesList'],
      extraOptions: {
        responseSchema: DeleteInsuranceTypeApiResponseSchema,
        requestSchema: DeleteInsuranceTypeApiArgSchema,
      },
    }),
    postInsuranceTypeSetActive: build.mutation<
      PostInsuranceTypeSetActiveApiResponse,
      PostInsuranceTypeSetActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}/set-active`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'insuranceTypesList',
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: PostInsuranceTypeSetActiveApiResponseSchema,
        requestSchema: PostInsuranceTypeSetActiveApiArgSchema,
      },
    }),
    postInsuranceTypeSetInactive: build.mutation<
      PostInsuranceTypeSetInactiveApiResponse,
      PostInsuranceTypeSetInactiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}/set-inactive`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'insuranceTypesList',
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: PostInsuranceTypeSetInactiveApiResponseSchema,
        requestSchema: PostInsuranceTypeSetInactiveApiArgSchema,
      },
    }),
    postInsuranceTypeSetDefault: build.mutation<
      PostInsuranceTypeSetDefaultApiResponse,
      PostInsuranceTypeSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}/set-default`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'insuranceTypesList',
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: PostInsuranceTypeSetDefaultApiResponseSchema,
        requestSchema: PostInsuranceTypeSetDefaultApiArgSchema,
      },
    }),
    postInsuranceTypeUnsetDefault: build.mutation<
      PostInsuranceTypeUnsetDefaultApiResponse,
      PostInsuranceTypeUnsetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/insurance-type/${queryArg.insuranceTypeId}/unset-default`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        'insuranceTypesList',
        {type: 'insurance', id: queryArg.insuranceTypeId},
      ],
      extraOptions: {
        responseSchema: PostInsuranceTypeUnsetDefaultApiResponseSchema,
        requestSchema: PostInsuranceTypeUnsetDefaultApiArgSchema,
      },
    }),
    getCodelistInsuranceTypes: build.query<
      GetCodelistInsuranceTypesApiResponse,
      GetCodelistInsuranceTypesApiArg
    >({
      query: () => ({
        url: `/service/v1/codelist/insurance-types`,
      }),
      providesTags: ['insuranceTypesList'],
      extraOptions: {
        responseSchema: GetCodelistInsuranceTypesApiResponseSchema,
        requestSchema: GetCodelistInsuranceTypesApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetInsuranceTypesQuery,
  usePostInsuranceTypeMutation,
  useGetInsuranceTypeQuery,
  usePatchInsuranceTypeMutation,
  useDeleteInsuranceTypeMutation,
  usePostInsuranceTypeSetActiveMutation,
  usePostInsuranceTypeSetInactiveMutation,
  usePostInsuranceTypeSetDefaultMutation,
  usePostInsuranceTypeUnsetDefaultMutation,
  useGetCodelistInsuranceTypesQuery,
} = metadaWorkshopInsuranceTypesApi;
